import React from "react";
import { PlatformLayout } from "../PlatformLayout";
import { PopupProvider } from "../ui/popup/Popup";
import { DMLogo } from "../assets-management";
import { ToastProvider } from "./hooks/useCustomToast";

export function Layout({ children, contentWide, withoutNavigation = false }: { children: React.ReactNode, contentWide?: boolean, withoutNavigation?: boolean }) {
  return <PlatformLayout topId={"AssetsManagement"} header={<DMLogo />}
    contentWide={contentWide}
    {...(withoutNavigation ? { withoutMainMenu: true } : {})}
  >
    <PopupProvider>
      <ToastProvider>
        <div className="AssetsManagement">
          {children}
        </div>
      </ToastProvider>
    </PopupProvider>
  </PlatformLayout>
}